<div class="flex h-screen overflow-hidden bg-gray-100 dark:bg-gray-950">
  <app-conservatore-not-accepted-dialog />
  <!-- Sidebar -->
  @if (!isSidebarHidden()) {
    <div class="w-96">
      <app-sidebar />
    </div>
  }
  <!-- Main Content Area -->
  <div class="flex flex-1 flex-col min-w-0 overflow-hidden">
    <!-- Header -->
    <app-header />
    <!-- Page Content -->
    <div class="relative flex flex-1 flex-col min-h-0 overflow-hidden">
      <app-content-loading />
      <main class="flex-1 overflow-y-auto p-2 pb-24 lg:p-3 lg:pb-24">
        <router-outlet />
      </main>
    </div>
  </div>
</div>
